"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarConditionStepDefinition = void 0;
const TemplateTypes_1 = require("../../../../Enum/TemplateTypes");
const RepositoryTypes_1 = require("../../../../Enum/RepositoryTypes");
const WidgetFormStepPluginDefinition_1 = require("../../../../Plugin/WidgetStep/WidgetFormStepPluginDefinition");
const WidgetEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/WidgetEvents");
const StepEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/StepEvents");
const StepTypes_1 = require("../../../../Enum/StepTypes");
const QuestionnaireFormStepBase_1 = require("./QuestionnaireFormStepBase");
const QuestionnaireTypes_1 = require("../../../../Enum/QuestionnaireTypes");
const QuestionnaireForm_1 = require("../../../../Plugin/FormHandler/QuestionnaireForm");
class CarConditionStep extends QuestionnaireFormStepBase_1.default {
    constructor(definition, widgetConfig, state, eventContext, ractiveWrapper, formHandlerProvider, repoFactory, questionnaireInputToRequestTransformer) {
        super(definition, widgetConfig, state, eventContext, ractiveWrapper, formHandlerProvider);
        this.questionnaireOrder = [
            QuestionnaireTypes_1.QuestionnaireTypes.CONDITION,
            QuestionnaireTypes_1.QuestionnaireTypes.OPTIONAL_EXTRAS,
            QuestionnaireTypes_1.QuestionnaireTypes.DETAILS,
            QuestionnaireTypes_1.QuestionnaireTypes.HISTORY,
            QuestionnaireTypes_1.QuestionnaireTypes.FINANCE,
            QuestionnaireTypes_1.QuestionnaireTypes.FACTORY_FITTED_OPTIONS,
        ];
        this.questionnaireWithValuationRepo = repoFactory.create(RepositoryTypes_1.RepositoryTypes.QUESTIONNAIRE_WITH_VALUATION, { config: widgetConfig });
        this.answeredQuestionnaireRepo = repoFactory.create(RepositoryTypes_1.RepositoryTypes.ANSWERED_QUESTIONNAIRE, { config: widgetConfig });
        this.answeredDynamicQuestionnaireRepo = repoFactory.create(RepositoryTypes_1.RepositoryTypes.ANSWERED_DYNAMIC_QUESTIONNAIRE, { config: widgetConfig });
        this.valuationRepo = repoFactory.create(RepositoryTypes_1.RepositoryTypes.VALUATION, { config: widgetConfig });
        this.questionnaireRepo = repoFactory.create(RepositoryTypes_1.RepositoryTypes.QUESTIONNAIRE, { config: widgetConfig });
        this.dynamicQuestionnaireRepo = repoFactory.create(RepositoryTypes_1.RepositoryTypes.DYNAMIC_QUESTIONNAIRE_REPO, { config: widgetConfig });
        this.questionnaireInputToRequestTransformer = questionnaireInputToRequestTransformer;
    }
    /**
     * @inheritDoc
     * @see IContainerInjection
     */
    static create(definition, widgetConfig, state, eventContext, container) {
        return new this(definition, widgetConfig, state, eventContext, container.get("ractive_wrapper"), container.get("plugin.provider.form_handler"), container.get("factory.repository"), container.get('transformer.questionnaire_input_to_request'));
    }
    /**
     * @inheritDoc
     */
    getTemplate() {
        return this.widgetConfig.getTemplate(TemplateTypes_1.TemplateTypes.CAR_CONDITION_STEP).getTemplate();
    }
    /**
     * @inheritDoc
     */
    initialize() {
        this.state.setOptionalExtras("No optional extras");
        return Promise.all([
            this.questionnaireWithValuationRepo.get(QuestionnaireTypes_1.QuestionnaireTypes.CONDITION, this.state.getValuation()),
            this.questionnaireWithValuationRepo.get(QuestionnaireTypes_1.QuestionnaireTypes.OPTIONAL_EXTRAS, this.state.getValuation()),
            this.questionnaireRepo.get(QuestionnaireTypes_1.QuestionnaireTypes.DETAILS),
            this.questionnaireRepo.get(QuestionnaireTypes_1.QuestionnaireTypes.HISTORY),
            this.questionnaireRepo.get(QuestionnaireTypes_1.QuestionnaireTypes.FINANCE),
            this.dynamicQuestionnaireRepo.get(QuestionnaireTypes_1.QuestionnaireTypes.FACTORY_FITTED_OPTIONS, this.state.getValuation()),
        ]).then((questionnaires) => {
            const valuation = this.state.getValuation();
            this.questionnaireOrder.forEach((type, index) => this.state.setQuestionnaire(type, questionnaires[index][0]));
            if (!valuation.getAnsweredQuestionnaires().count()) {
                return;
            }
            this.questionnaireOrder.forEach((type, index) => {
                const answers = valuation.getAnsweredQuestionnaires()
                    .find((answersDto) => answersDto.getId() === type);
                this.state.setQuestionnaireAnswers(type, answers);
            });
        });
    }
    /**
     * @inheritDoc
     */
    getQuestionnaire() {
        return this.questionnaireOrder.map((type) => this.state.getQuestionnaire(type));
    }
    /**
     * @inheritDoc
     */
    submit(answersData) {
        const valuation = this.state.getValuation();
        const transformer = this.questionnaireInputToRequestTransformer;
        return Promise.all([
            this.answeredQuestionnaireRepo.create(valuation, QuestionnaireTypes_1.QuestionnaireTypes.CONDITION, transformer.toCondition(answersData)),
            this.answeredQuestionnaireRepo.create(valuation, QuestionnaireTypes_1.QuestionnaireTypes.OPTIONAL_EXTRAS, transformer.toExtraOptions(answersData)),
            this.answeredQuestionnaireRepo.create(valuation, QuestionnaireTypes_1.QuestionnaireTypes.DETAILS, transformer.toDetails(answersData)),
            this.answeredQuestionnaireRepo.create(valuation, QuestionnaireTypes_1.QuestionnaireTypes.HISTORY, transformer.toHistory(answersData)),
            this.answeredQuestionnaireRepo.create(valuation, QuestionnaireTypes_1.QuestionnaireTypes.FINANCE, transformer.toFinance(answersData)),
            this.answeredDynamicQuestionnaireRepo.create(valuation, this.state.getQuestionnaire(QuestionnaireTypes_1.QuestionnaireTypes.FACTORY_FITTED_OPTIONS).getId(), transformer.toFactoryFitted(answersData))
        ]).then(() => {
            this.eventContext.emit(StepEvents_1.StepEvents.STEP_FINISHED);
        }).catch((error) => {
            // @TODO: Handle errors.
            this.eventContext.emit(WidgetEvents_1.WidgetEvents.INTERNAL_ERROR, error);
        });
    }
}
exports.default = CarConditionStep;
exports.CarConditionStepDefinition = new WidgetFormStepPluginDefinition_1.default({
    id: StepTypes_1.StepTypes.CAR_CONDITION,
    form_id: QuestionnaireForm_1.QuestionnaireFormDefinition.getId(),
    class: CarConditionStep,
    priority: 3500
});
